/**
 * Get a user-friendly error message from an API error.
 * Prefers server message, falls back to status text or generic message.
 */
export function getApiErrorMessage(err, fallback = 'Something went wrong') {
  if (!err) return fallback;
  if (err.code === 'ERR_NETWORK' || !err.response) {
    return 'Connection error. Please check your network.';
  }
  const msg = err.response?.data?.message || err.response?.data?.error || err.message;
  if (typeof msg === 'string' && msg.trim()) return msg.trim();
  if (err.response?.status === 401) return 'Please sign in again';
  if (err.response?.status === 403) return 'Access denied';
  if (err.response?.status >= 500) return 'Server error. Please try again later.';
  return fallback;
}
